<div class="bottom-sheet-inner df-opt-sheet">
  <div class="df-opt-sticky">
    <div class="bottom-sheet-handle"></div>
    <div class="df-opt-head d-flex ion-align-items-start">
      <div class="flex-1">
        <div class="df-opt-title font800 dutyfree-text-color">{{ title }}</div>
        <div class="fs-2 dutyfree-text-secondary mart4">
          {{ 'dutyfree.checkout.option_picker_sub' | translate }}
        </div>
      </div>
      <button
        type="button"
        class="df-opt-x df-plain d-flex ion-align-items-center ion-justify-content-center cursor-pointer"
        (click)="close()"
        [attr.aria-label]="'modals.generic_alert.close' | translate"
      >
        <ion-icon name="close-outline" class="font20"></ion-icon>
      </button>
    </div>

    <div
      class="df-opt-search d-flex ion-align-items-center card-white-background-color padl10 padr10"
      *ngIf="showSearch"
    >
      <ion-icon name="search-outline" class="font18 dutyfree-text-muted"></ion-icon>
      <input
        type="search"
        class="df-opt-search-input flex-1 fs-3 dutyfree-text-color ion-no-padding"
        [placeholder]="'dutyfree.checkout.option_picker_search' | translate"
        [value]="searchQuery"
        (input)="searchQuery = $any($event.target).value"
        autocomplete="off"
      />
      <button
        type="button"
        class="df-plain df-opt-search-clear d-flex ion-align-items-center ion-justify-content-center cursor-pointer ion-no-padding dutyfree-text-secondary"
        *ngIf="searchQuery"
        (click)="clearSearch()"
        [attr.aria-label]="'dutyfree.checkout.option_picker_clear' | translate"
      >
        <ion-icon name="close-circle-outline" class="font18"></ion-icon>
      </button>
    </div>
  </div>

  <div class="df-opt-scroll ion-content-scroll-host">
    <div
      class="df-opt-empty d-flex flex-col ion-align-items-center ion-justify-content-center ion-text-center"
      *ngIf="!filteredOptions.length"
    >
      <div class="df-opt-empty-icon d-flex ion-align-items-center ion-justify-content-center">
        <ion-icon name="search-outline" class="font28"></ion-icon>
      </div>
      <div class="fs-4 font700 dutyfree-text-color mart10">
        {{ 'dutyfree.checkout.option_picker_no_match' | translate }}
      </div>
    </div>

    <button
      type="button"
      class="df-opt-card df-plain d-flex ion-align-items-center w100 ion-text-start cursor-pointer card-white-background-color"
      *ngFor="let option of filteredOptions"
      [class.selected]="option === selected"
      (click)="selectOption(option)"
    >
      <span
        class="fs-3 dutyfree-text-color flex-1"
        [class.font700]="option === selected"
        [class.font600]="option !== selected"
      >{{ option }}</span>
    </button>
  </div>
</div>
